<template>
  <div class="mb-3">
    <custom-callout
      :has-toggle="false"
      :controlled="true"
      :border-color="getPeiStatusColor()"
    >
      <div class="row mt-2">
        <div
          class="col-sm-12 col-md-2 col-lg-2 py-3 border-right-2 d-flex flex-column align-items-start justify-content-start"
        >
          <custom-balloon
            class="w-100 p-2 mt-2"
            :text="value.peiStatusDescription"
            :background-color="getPeiStatusClass()"
          />
        </div>
        <div class="col-md-8 pt-3 grey-divider">
          <div :class="['row', { 'pt-2': isMobile }]">
            <div class="col-md-2 col-6">
              <div class="info-text-title">Año</div>
              <p>
                {{ value.academicYear }}
              </p>
            </div>
            <div class="col-md-1 col-6">
              <div class="info-text-title">Tipo</div>
              <p>
                {{ getPeiTypeDesc }}
              </p>
            </div>
            <div class="col-md-2 col-6">
              <div class="info-text-title">Número</div>
              <p>
                {{ parsePeiId }}
              </p>
            </div>
            <div class="col-md-2 col-6">
              <div class="info-text-title">Enmienda</div>
              <p>
                {{ parseGeneralRevisionNo }}
              </p>
            </div>
            <div class="col-md-2 col-6">
              <div class="info-text-title">Fecha Discusión COMPU</div>
              <p>
                {{ value.generalClosedDate | date('DD/MMM/YYYY') }}
              </p>
            </div>
            <div class="col-md-3 col-6">
              <div class="info-text-title">Fecha Inicio de Servicio</div>
              <p>
                {{ value.projectedDate.projectedDate | date('DD/MMM/YYYY') }}
              </p>
            </div>
          </div>
        </div>

        <div class="col-md-2 pt-3" :class="readOnly ? 'pl-0' : ''">
          <div class="row w-100 custom-button">
            <DropDown
              :key="value.peiIdFormatted"
              :items="getMenuItems"
              id="dd-actions"
            />
          </div>
        </div>
      </div>
    </custom-callout>
    <Error
      v-if="value.atServiceAmmendment || value.signedWithoutChecklist"
      is-alert-mode
      class="px-3"
      :canClose="false"
      isBorderless
      message="Esta Enmienda de PEI fue generada por proceso de Asistencia Tecnológica"
      @close="closeErrorPanel()"
    />
    <Error
      v-if="value.hasCommentFromParentPortal && showError"
      is-alert-mode
      canClose
      isBorderless
      message="El PEI cuenta con un comentario realizado por el padre, madre y/o encargado(o). Favor dirigirse a los comentarios."
      @close="closeErrorPanel()"
    />
    <Error
      v-if="hasCancelComment"
      is-alert-mode
      :canClose="false"
      isBorderless
      :message="`Comentario de Cancelación: ${this.value.cancelComment}`"
      @close="closeErrorPanel()"
    />
  </div>
</template>

<script>
import moment from 'moment';
import 'moment/locale/es-do';
import store from '@/store/index';
import DropDown from 'dropdown';
import CustomBalloon from 'custom-balloon';
import CustomCallout from 'custom-callout';
import Error from '@/components/common/Error.vue';
import PeiStatus from '@/utils/constants/pei/peiStatus';
import userRoles from '@/utils/constants/userRoles';
import mixAlert from '@/mixin/alert.mixin';
import mixWait from '@/mixin/loading.mixin';
import { createNamespacedHelpers } from 'vuex';
import academicYears from '@/utils/constants/academicYears';

import {
  getStudentInfoEducationalCompensatoryRequest as _studentInfoEducationalCompensatoryRequest,
  getMonths as _getMonths,
} from '@/services/pei/visit-registry.js';
const { mapActions } = createNamespacedHelpers('$_admendment');
export default {
  name: 'PeiHistoryResultRow',
  components: {
    CustomBalloon,
    CustomCallout,
    DropDown,
    Error,
  },
  mixins: [mixAlert, mixWait],
  data() {
    return {
      showError: true,
      reportUpdateRoles: [
        userRoles.admin,
        userRoles.adminIl,
        userRoles.adminSaee,
        userRoles.tecnico,
      ],
    };
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    hasSaee10Report: {
      type: Boolean,
      default: false,
    },
    readOnly: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    showSaee10Report() {
      return this.hasSaee10Report; // && this.value.peiStatusId == PeiStatus.Firmado;
    },
    isMobile() {
      return store.getters.getIsMobileDensity;
    },
    isPS() {
      return !['0', '2'].includes(this.value.unilateralFlag);
    },
    isPSC() {
      return this.value.unilateralFlag === '2';
    },
    getPeiTypeDesc() {
      switch (this.value.unilateralFlag) {
        case '0':
        case 0:
          return 'PEI';
        case '2':
        case 2:
          return 'PSC';
        default:
          return 'PS';
      }
    },
    parseGeneralRevisionNo() {
      return this.value.generalRevisionNo.toString().padStart(2, '0');
    },
    parsePeiId() {
      return (
        this.value.peiIdFormatted.slice(0, 4) +
        '-' +
        this.value.peiIdFormatted.slice(4, 10)
      );
    },
    canUpdatePeiReport() {
      const status = [
        PeiStatus.Completado,
        PeiStatus.Firmado,
        PeiStatus.SignedWithControversy,
      ];
      const validStatus = status.some(
        (statusId) => statusId == this.value.peiStatusId
      );

      let hasRoleForUpdatePeiReport = false;

      if (this.reportUpdateRoles === undefined) {
        hasRoleForUpdatePeiReport = true; // show
      }

      if (this.reportUpdateRoles) {
        hasRoleForUpdatePeiReport = this.reportUpdateRoles.some(
          (role) => role == this.userRole
        );
      }

      return validStatus && hasRoleForUpdatePeiReport;
    },
    canDownloadEquipmentReportAT() {
      const isSigned =
        this.value.peiStatusId == PeiStatus.Firmado ||
        this.value.peiStatusId == PeiStatus.PartialSignedPendingFunds ||
        this.value.peiStatusId == PeiStatus.SignedWithControversy;

      const isParameterEnabled =
        store.getters.getRequireUsageGuaranteeCompletionEnabled === 'true';

      return isSigned && isParameterEnabled;
    },
    getMenuItems() {
      const isSigned =
        this.value.peiStatusId == PeiStatus.Firmado ||
        this.value.peiStatusId == PeiStatus.PartialSignedPendingFunds ||
        this.value.peiStatusId == PeiStatus.SignedWithControversy;

      const invalidStatuses = [PeiStatus.Cancelado, PeiStatus.Incompleto];
      const validStatus = !invalidStatuses.some(
        (id) => id === this.value.peiStatusId
      );

      if (this.readOnly) {
        return [
          {
            label: 'Reporte del PEI o PS',
            icon: 'fas fa-print text-green',
            click: () => this.$emit('getReportsPEIPS'),
            visible: validStatus,
          },
        ];
      }

      let items = [
        {
          label: 'Entrar',
          icon: 'fas fa-file-import ml-n1 text-green',
          click: () => {
            this.getPeiAdmendment(this.value.peiIdFormatted);
            this.getCorrelationParameter();
            this.getPartEvaluationAmendmentServiceById(
              this.value.peiIdFormatted
            );
            this.$emit('goPeiTabs');
          },
        },
        {
          label: 'Ver Documentos',
          icon: 'fas fa-file-invoice text-green',
          click: () => this.$emit('goDocuments'),
        },
        {
          label: 'Cuestionario del PEI en Controversia',
          icon: 'fas fa-clipboard-list-check text-green',
          click: () => this.$emit('goToControversy'),
          visible: this.value.peiControversyFlag,
        },
        {
          label: 'Reporte del PEI o PS',
          icon: 'fas fa-print text-green',
          click: () => this.$emit('getReportsPEIPS'),
          visible: validStatus && !this.value.canDownloadFromStorage,
        },
        {
          label: 'Imprimir PEI o PS Firmado',
          icon: 'fas fa-print text-green',
          click: () => this.$emit('getReportsPEIPSFromStorage'),
          visible: this.value.canDownloadFromStorage,
        },
        {
          label: 'Reporte PEI o PS en blanco',
          icon: 'fas fa-print text-green',
          click: () => this.$emit('getPeiReportBlank'),
          visible: validStatus && this.value.canDownloadBlankPeiOrPs,
        },
        {
          label: 'Ver SAEE-10',
          icon: 'fas fa-print text-green',
          click: () => this.$emit('getSAEE10Report'),
          visible: this.showSaee10Report,
        },
        {
          label: 'Reporte Indicador 13',
          icon: 'fas fa-print text-green',
          click: () => this.$emit('getInd13PeiReport'),
          visible: this.value.ind13Flag,
        },
        {
          label: 'Reporte Indicador 7',
          icon: 'fas fa-print text-green',
          click: () => this.$emit('getInd7PeiReport'),
          visible: this.value.ind7Flag,
        },
        {
          label: 'Reporte de Guía de AT',
          icon: 'fas fa-print text-green',
          click: () => this.$emit('getAtServiceReport'),
          visible: this.verifyPeiStatusForAtService(),
        },
        {
          label: 'Actualizar Reporte del PEI o PS',
          icon: 'fas fa-redo text-orange',
          click: () => this.$emit('deletePeiReport'),
          visible:
            this.canUpdatePeiReport && !this.value.canDownloadFromStorage,
        },
        {
          label: 'Reporte Solicitud de Transportación',
          icon: 'fas fa-print text-green',
          click: () => this.$emit('getTransportationRequestReport'),
          visible: isSigned && this.value.transportationReportFlag,
        },
        {
          label: 'Reporte Solicitud de Transportación AEE',
          icon: 'fas fa-print text-green',
          click: () => this.$emit('getTransportationRequestReportAEE'),
          visible: isSigned && this.value?.transportationReportAEEFlag,
        },
        {
          label: 'Ver Hoja de Referido ',
          icon: 'fas fa-file-download text-green',
          click: () => this.$emit('downloadSheetRefferal'),
          visible: true,
        },
        {
          label: 'Comentario',
          icon: 'fas fa-file-alt text-green',
          click: () =>
            this.$emit('goToComments', {
              academicYearId: this.value.academicYearId,
              hasCommentFromParentPortal: this.value.hasCommentFromParentPortal,
            }),
          visible: true,
        },
        {
          label: 'Generar Referido ',
          icon: 'fas fa-redo text-green',
          click: this.generateReferral,
          visible: this.value.canGenerateReferral,
        },
        {
          label: 'Reporte Uso e Inventario Equipo AT',
          icon: 'fas fa-file-download text-green',
          click: () => this.$emit('downloadEquipmentAT'),
          visible:
            !this.isPS &&
            !this.isPSC &&
            this.canDownloadEquipmentReportAT &&
            this.value.hasPeiAtAnswerEquipment &&
            this.value.academicYearId >= academicYears.Y2024_2025,
        },
        {
          label: 'Registrar Visita',
          icon: 'fas fa-user-clock text-green',
          click: () => this.goToVisitRegistry(),
          visible: this.value.hasEducationalServices,
        },
        {
          label: 'Informe de Logros',
          icon: 'fas fa-user-edit text-green',
          click: () => this.goToAcademicProgress(),
          visible: isSigned && this.isPSC,
        },
      ];

      return items;
    },
    hasCancelComment() {
      const comment = this.value?.cancelComment?.trim() || '';
      return comment.length > 0;
    },
  },
  methods: {
    ...mapActions([
      'getPeiAdmendment',
      'getCorrelationParameter',
      'getPartEvaluationAmendmentServiceById',
    ]),
    getPeiStatusColor() {
      let statusClass = '';

      switch (this.value.peiStatusId.toString()) {
        case PeiStatus.Borrador:
          statusClass = 'pink';
          break;
        case PeiStatus.Cancelado:
          statusClass = 'brown';
          break;
        case PeiStatus.Completado:
          statusClass = 'yellow';
          break;
        case PeiStatus.Firmado:
          statusClass = 'green-light';
          break;
        case PeiStatus.Incompleto:
          statusClass = 'brown';
          break;
        case PeiStatus.CompletedWithPendingFunds:
          statusClass = 'yellow';
          break;
        case PeiStatus.PartialSignedPendingFunds:
          statusClass = 'green-light';
          break;
        case PeiStatus.SignedWithControversy:
          statusClass = 'green-light';
          break;
        case PeiStatus.ProposalRejected:
          statusClass = 'violet';
          break;
      }

      return statusClass;
    },
    getPeiStatusClass() {
      let statusClass = '';
      switch (this.value.peiStatusId.toString()) {
        case PeiStatus.Borrador:
          statusClass = 'pink';
          break;
        case PeiStatus.Cancelado:
          statusClass = 'brown';
          break;
        case PeiStatus.Completado:
          statusClass = 'yellow';
          break;
        case PeiStatus.Firmado:
          statusClass = 'green-light';
          break;
        case PeiStatus.Incompleto:
          statusClass = 'brown';
          break;
        case PeiStatus.CompletedWithPendingFunds:
          statusClass = 'violet';
          break;
        case PeiStatus.PartialSignedPendingFunds:
          statusClass = 'green-light';
          break;
        case PeiStatus.SignedWithControversy:
          statusClass = 'green-light';
          break;
        case PeiStatus.ProposalRejected:
          statusClass = 'violet';
          break;
      }

      return statusClass;
    },
    closeErrorPanel() {
      this.showError = false;
      this.$emit('closeShowErrorPanel');
    },
    verifyPeiStatusForAtService() {
      return (
        this.value.peiStatusId == PeiStatus.Firmado && this.value.atServiceFlag
      );
    },
    generateReferral() {
      if (this.value.isInPrivateSchool) {
        this.ShowToast(
          'error',
          'El Estudiante debe encontrarse en escuela pública.',
          'error'
        );
        return;
      }
      this.$emit('generateReferral');
    },
    async goToVisitRegistry() {
      try {
        const item = await this.fectItemInfo();

        if (!item) {
          this.$router.push({ name: 'visit-registration' });
          return;
        }

        const months = (await _getMonths(item.academicYearId)).data;
        const academicYearDescription = item.academicYearDescription;
        const monthNumber =
          moment(this.value.projectedDate.projectedDate).month() + 1;
        const currentPeriodYear = moment(item.academicYearStartDate).year();
        const initialPeriod = months[0];
        const initialPeriodInfo = {
          year: currentPeriodYear,
          monthNumber,
        };
        const currentPeriod = {
          year: parseInt(
            monthNumber > 6
              ? academicYearDescription.split('-')[0]
              : academicYearDescription.split('-')[1]
          ),
          monthNumber,
        };
        const disabledPeriods = months
          .slice(_.findIndex(months, { id: monthNumber }) + 1)
          .map(({ monthNumber, year }) =>
            moment()
              .date(1)
              .month(monthNumber - 1)
              .year(year)
              .toDate()
          );
        const params = {
          ...item,
          disabledPeriods,
          initialPeriod,
          initialPeriodInfo,
          currentPeriod,
        };

        this.$router.push({
          name: 'visit-registration',
          params: {
            ...params,
          },
        });
      } catch (error) {
        this.ShowToast('Error', error.message || 'Ocurrió un error', 'error');
      }
    },
    async goToAcademicProgress() {
      this.$router.push({
        name: 'pres-main-pei',
        params: {
          onlyPsc: true,
          studentSieId: this.value.studentSieId,
        },
      });
    },
    async fectItemInfo() {
      const response = await _studentInfoEducationalCompensatoryRequest(
        this.value.studentSieId
      );
      return response?.data;
    },
  },
};
</script>

<style scoped>
.student-search-alert-error {
  margin: 0 !important;
}

/************ CUSTOM BADGES *************/
.badges {
  color: black;
  font-size: 16px;
  width: 100%;
  height: 42px;
  line-height: 20px;
  border-radius: 20px;
  padding: 10px;
}
.badge-erase {
  background: #fcc9c8;
}
.badge-cancel {
  background: #d5b89a;
}
.badge-complete {
  background: #f8ea80;
}
.badge-signed {
  background: #a3e5b3;
}
.badge-incomplete {
  background: #d5b89a;
}
.badge-waiting {
  background: #a7e6dc;
}
.badge-partial {
  background: #a3e5b3;
}
.badge-pending-funds {
  background: #ddb3d7;
}
.badge-pending {
  background: #f8ea80;
}
</style>
